import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';
import { sessionService } from '../../services/SessionService';
import swal from 'sweetalert';

interface EditContractProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class EditContract extends React.Component<EditContractProps> {

    @observable private contract: any;
    @observable private isLoaded = false;
    @observable private redirect = false;
    @observable private validationErrors: string[] = [];
    @observable private clients: any = [];
    @observable private packages: any = [];
    @observable private cutoffs: any = [];
    @observable private sectorials: any = [];
    @observable private availableIps: any = [];
    @observable private availablePorts: any = [];
    @observable private usedIps: any = [];
    @observable private usedPorts: any = [];
    @observable private payment_types = [
        { id: "COBRADOR", name: "Cobrador" },
        { id: "DEPOSITO", name: "Deposito" },
        { id: "TRANSFERENCIA", name: "Transferencia" }
    ];
    @observable private house_types = [
        { id: "Propia", name: "Propia" },
        { id: "Renta", name: "Renta" }
    ]
    @observable private statuses = [
        { id: "Pendiente Instalacion", name: "Pendiente Instalacion" },
        { id: "Activo", name: "Activo" },
        { id: "Pendiente Desconexion", name: "Pendiente Desconexion" },
        { id: "Desconectado", name: "Desconectado" },
        { id: "Pendiente Conexion", name: "Pendiente Conexion" },
        { id: "Cerrado", name: "Cerrado" },
        { id: "Pendiente Retiro", name: "Pendiente Retiro" },
        { id: "Empleado", name: "Empleado" }
    ]
    
     @observable private usos_cfdi = [
            { id: "G01", name: "G01 - Adquisición de mercancías" },
        { id: "G02", name: "G02 - Devoluciones, descuentos o bonificaciones" },
        { id: "G03", name: "G03 - Gastos en general" },
        { id: "I01", name: "I01 - Construcciones" },
        { id: "I02", name: "I02 - Mobiliario y equipo de oficina por inversiones" },
        { id: "I03", name: "I03 - Equipo de transporte" },
        { id: "I04", name: "I04 - Equipo de cómputo y accesorios" },
        { id: "I05", name: "I05 - Dados, troqueles, moldes, matrices y herramental" },
        { id: "I06", name: "I06 - Comunicaciones telefónicas" },
        { id: "I07", name: "I07 - Comunicaciones satelitales" },
        { id: "I08", name: "I08 - Otra maquinaria y equipo" },
        { id: "D01", name: "D01 - Honorarios médicos, dentales y gastos hospitalarios" },
        { id: "D02", name: "D02 - Gastos médicos por incapacidad o discapacidad" },
        { id: "D03", name: "D03 - Gastos funerales" },
        { id: "D04", name: "D04 - Donativos" },
        { id: "D05", name: "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)" },
        { id: "D06", name: "D06 - Aportaciones voluntarias al SAR" },
        { id: "D07", name: "D07 - Primas por seguros de gastos médicos" },
        { id: "D08", name: "D08 - Gastos de transportación escolar obligatoria" },
        { id: "D09", name: "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones" },
        { id: "D10", name: "D10 - Pagos por servicios educativos (colegiaturas)" },
        { id: "CP01", name: "CP01 - Pagos" },
        { id: "CN01", name: "CN01 - Nómina" },
        { id: "S01", name: "S01 - Sin efectos fiscales" }
        ];
        @observable private regimen_fiscal = [
            { id: "605", name: "605 - Sueldos y Salarios e Ingresos Asimilados a Salarios" },
            { id: "626", name: "626 - Régimen Simplificado de Confianza (RESICO)" },
            { id: "612", name: "612 - Actividades Empresariales y Profesionales" },
            { id: "606", name: "606 - Régimen de Arrendamiento" },
            { id: "625", name: "625 - Régimen de Actividades Empresariales con Ingresos a través de Plataformas Tecnológicas" },
            { id: "607", name: "607 - Régimen de Enajenación o Adquisición de Bienes" },
            { id: "608", name: "608 - Régimen de los Demás Ingresos" },
            { id: "611", name: "611 - Ingresos por Dividendos (Socios y Accionistas)" },
            { id: "614", name: "614 - Ingresos por Intereses" },
            { id: "615", name: "615 - Ingresos por Obtención de Premios" },
            { id: "621", name: "621 - Régimen de Incorporación Fiscal (RIF)" },
            { id: "616", name: "616 - Sin Obligaciones Fiscales" },
            { id: "601", name: "601 - Régimen General de Ley Personas Morales" },
            { id: "626", name: "626 - Régimen Simplificado de Confianza (RESICO) para Personas Morales" },
            { id: "603", name: "603 - Personas Morales con Fines no Lucrativos" },
            { id: "620", name: "620 - Sociedades Cooperativas de Producción que Optan por Diferir sus Ingresos" },
            { id: "622", name: "622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras" },
            { id: "623", name: "623 - Régimen Opcional para Grupos de Sociedades" },
            { id: "624", name: "624 - Coordinados" }
        ];
        @observable private hasPorts: boolean = false;
        @observable private originalAddress: any = null;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;
        http.get(`/api/contract/read/${id}`).then((response) => {
            this.contract = response.data;
            this.contract.mac = this.contract.mac ? this.contract.mac : "";
            // Asegurar que el puerto sea string para el dropdown
            if (this.contract.port !== null && this.contract.port !== undefined && this.contract.port !== "") {
                this.contract.port = String(this.contract.port);
            }
            // Guardar la dirección original del contrato
            this.originalAddress = {
                address_street: this.contract.address_street || "",
                address_colonia: this.contract.address_colonia || "",
                address_interior: this.contract.address_interior || "",
                address_exterior: this.contract.address_exterior || "",
                address_zipcode: this.contract.address_zipcode || "",
                address_reference: this.contract.address_reference || ""
            };
        })
            .then(() => {
                return http.get(`/api/client/readAll`).then((response) => {
                    this.clients = response.data.response;
                })
            })
            .then(() => {
                return http.get(`/api/package/read`).then((response) => {
                    this.packages = response.data.response;
                })
            })
            .then(() => {
                return http.get(`/api/cutoff/read`).then((response) => {
                    this.cutoffs = response.data.response;
                })
            })
            .then(() => {
                return http.get(`/api/sectorial/available`).then((response) => {
                    this.sectorials = response.data.response;
                });
            })
            .then(() => {
                const request = JSON.stringify({
                    id: this.contract.sectorial_id
                });
                return http.post(`/api/sectorial/ips`, request).then((response) => {
                    this.usedIps = response.data.response;
                    if (this.contract.sectorial_id !== "") {
                        this.generateAvailableIps();
                    }
                })
            })
            .then(() => {
                const request = JSON.stringify({
                    id: this.contract.sectorial_id
                });
                return http.post(`/api/sectorial/ports`, request).then((response) => {
                    // El endpoint devuelve los puertos disponibles directamente en response
                    const availablePortsFromApi = response.data.response || [];
                    this.availablePorts = availablePortsFromApi.map((port: any) => ({
                        id: String(port),
                        name: String(port)
                    }));
                    // Si el contrato ya tiene un puerto asignado, asegurarse de que esté en la lista
                    if (this.contract.port && this.contract.port !== "" && this.contract.port !== null) {
                        const currentPortStr = String(this.contract.port);
                        const portExists = this.availablePorts.find((p: any) => p.id === currentPortStr || String(p.id) === currentPortStr);
                        if (!portExists) {
                            this.availablePorts.push({
                                id: currentPortStr,
                                name: currentPortStr
                            });
                        }
                        // Asegurar que el valor del puerto coincida exactamente con el formato del dropdown
                        this.contract.port = currentPortStr;
                    }
                    // Si hay puertos disponibles y no hay uno seleccionado, seleccionar el primero
                    if (this.availablePorts.length > 0 && (!this.contract.port || this.contract.port === "")) {
                        this.contract.port = this.availablePorts[0].id;
                    }
                    // Verificar si el sectorial tiene puertos
                    const sectorial = this.sectorials.find((x: any) => x.id === this.contract.sectorial_id);
                    this.hasPorts = sectorial && sectorial.ports_number && Number(sectorial.ports_number) > 0;
                    this.isLoaded = true;
                })
            })
            .catch(() => {
                toast.error("Error cargando contrato");
            });
    }

    private hasAddressChanged = (): boolean => {
        if (!this.originalAddress) {
            return false;
        }
        return (
            (this.contract.address_street || "") !== (this.originalAddress.address_street || "") ||
            (this.contract.address_colonia || "") !== (this.originalAddress.address_colonia || "") ||
            (this.contract.address_interior || "") !== (this.originalAddress.address_interior || "") ||
            (this.contract.address_exterior || "") !== (this.originalAddress.address_exterior || "") ||
            (this.contract.address_zipcode || "") !== (this.originalAddress.address_zipcode || "") ||
            (this.contract.address_reference || "") !== (this.originalAddress.address_reference || "")
        );
    }

    private scrollToBillingAddress = () => {
        const billingSection = document.getElementById('datos-fiscales-section');
        if (billingSection) {
            billingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // Resaltar la sección brevemente
            billingSection.style.transition = 'background-color 0.3s';
            billingSection.style.backgroundColor = '#fff3cd';
            setTimeout(() => {
                billingSection.style.backgroundColor = '';
            }, 2000);
        }
    }

    private addNotes = () => {
        // Verificar si cambió la dirección del contrato
        if (this.hasAddressChanged()) {
            swal({
                title: "Dirección del contrato modificada",
                text: "Se acaba de editar la dirección del contrato. ¿También quieres editar la dirección de facturación?",
                icon: "info",
                buttons: {
                    cancel: {
                        text: "No editar",
                        value: false,
                        visible: true,
                        closeModal: true,
                    },
                    confirm: {
                        text: "Editar",
                        value: true,
                        visible: true,
                        closeModal: true,
                    }
                }
            })
            .then((shouldEditBilling) => {
                if (shouldEditBilling) {
                    // Hacer scroll a la sección de facturación después de que se cierre el modal
                    setTimeout(() => {
                        this.scrollToBillingAddress();
                    }, 300);
                } else {
                    // Continuar con el flujo normal de guardar
                    this.continueWithSave();
                }
            })
            .catch(() => {
                // Si el usuario cierra el modal sin seleccionar, no hacer nada
            });
        } else {
            // Si no cambió la dirección, continuar con el flujo normal
            this.continueWithSave();
        }
    }

    private continueWithSave = () => {
        swal({
            title: "Notas de Edicion",
            text: "Escribe la razon de la edicion:",
            content: {
                element: "input"
            }
        })
            .then(test => {
                this.contract.notes_edition = test;
            }).then(this.onSubmit);
    }

    private handleSectorialChange = () => {
        if (this.contract.sectorial_id === "") {
            this.availableIps = [];
            this.contract.ip = "";
            this.availablePorts = [];
            this.contract.port = "";
            return;
        }
        this.contract.port = "";
        const request = JSON.stringify({
            id: this.contract.sectorial_id
        });
        http.post(`/api/sectorial/ips`, request).then((response) => {
            this.usedIps = response.data.response;
            this.generateAvailableIps();
        })
        http.post(`/api/sectorial/ports`, request).then((response) => {
            // El endpoint devuelve los puertos disponibles directamente en response
            const availablePortsFromApi = response.data.response || [];
            this.availablePorts = availablePortsFromApi.map((port: any) => ({
                id: String(port),
                name: String(port)
            }));
            // Si hay puertos disponibles y no hay uno seleccionado, seleccionar el primero
            if (this.availablePorts.length > 0 && (!this.contract.port || this.contract.port === "")) {
                this.contract.port = this.availablePorts[0].id;
            }
            // Verificar si el sectorial tiene puertos
            const sectorial = this.sectorials.find((x: any) => x.id === this.contract.sectorial_id);
            this.hasPorts = sectorial && sectorial.ports_number && Number(sectorial.ports_number) > 0;
        })
    }

    private generateAvailableIps = () => {
        const sectorial = this.sectorials.find((x: any) => {
            return x.id === this.contract.sectorial_id
        });

        this.availableIps = [];
        if (this.contract.ip && this.contract.ip !== "") { //Si ya tiene ip debemos incluir la actual
            this.availableIps.push({
                name: this.contract.ip,
                id: this.contract.ip
            });
        }
        if (sectorial) {
            for (let i = Number(sectorial.range_start); i <= Number(sectorial.range_end); i++) {
                if (this.usedIps.indexOf(`${sectorial.ip_start}.${i}`) === -1) {
                    this.availableIps.push({
                        name: `${sectorial.ip_start}.${i}`,
                        id: `${sectorial.ip_start}.${i}`
                    });
                }
            }
            this.contract.ip = this.availableIps[0].id;
            this.setValidation(false, "ip");
        }
    }

     private generateAvailablePorts = () => {
        // Esta función ya no es necesaria porque los puertos disponibles
        // vienen directamente del API. Se mantiene por compatibilidad pero
        // la lógica principal está en handleSectorialChange e init.
        // Si el puerto actual del contrato no está en availablePorts, agregarlo
        if (this.contract.port && this.contract.port !== "") {
            const currentPortStr = String(this.contract.port);
            const portExists = this.availablePorts.find((p: any) => p.id === currentPortStr);
            if (!portExists) {
                this.availablePorts.push({
                    id: currentPortStr,
                    name: currentPortStr
                });
            }
        }
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.contract[name] = value;
        if (name === "sectorial_id") {
            this.handleSectorialChange();
        }
    }

    private setValidation = (value: boolean, name: string): void => {
        const error = this.validationErrors.indexOf(name);
        if (value && error === -1) {
            this.validationErrors.push(name);
        } else if (!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private onSubmit = (): void => {
        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }
        
        if (this.contract.id.toString().startsWith("W")) {
            this.contract.id = this.contract.id.substring(1);
        }

        // eslint-disable-next-line
        if (this.contract.reference_phone) {
            this.contract.reference_phone = this.contract.reference_phone.replace(/-/g, '');
        }
        if (this.contract.sectorial_id === null || this.contract.sectorial_id === "") {
            delete this.contract.sectorial_id;
            delete this.contract.ip;
        }
        if (this.contract.reference_phone === null || this.contract.reference_phone === "") {
            delete this.contract.reference_phone;
        }

        this.contract.updated_by = sessionService.getUserInfo().id;
        http.post(`/api/contract/update`, JSON.stringify(this.contract))
            .then(() => {
                toast.success(`Contrato actualizado`);
                this.redirect = true;
            }).catch((error) => {
                if (Array.isArray(error)) {
                    error.forEach((val) => {
                        toast.error(val);
                    })
                } else {
                    toast.error(error);
                }
            });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }

        if (this.redirect) {
            return <Redirect to="/contratos" />
        }
        return (
          <Fragment>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header card-header-rose card-header-text">
                    <div className="card-text">
                      <h4 className="card-title">
                        Editar contrato #{this.contract.id} -{" "}
                        {this.contract.address_street}{" "}
                        {this.contract.address_colonia}{" "}
                        {this.contract.address_interior}{" "}
                        {this.contract.address_exterior}
                      </h4>
                    </div>
                  </div>
                  <div className="card-body ">
                    <div className="row">
                      <div className="col-sm-10"></div>
                      <div className="col-sm-2">
                        <Link to={`../contratos`}>
                          <button className="btn btn-danger btn-sm  pull-right">
                            <i className="material-icons">highlight_off</i>
                            <div className="ripple-container"></div>
                          </button>
                        </Link>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <button
                          onClick={this.addNotes}
                          type="submit"
                          className="btn btn-primary pull-right"
                        >
                          Guardar cambios
                        </button>
                      </div>
                    </div>
                    <InputForm
                      name="client_id"
                      label="Cliente"
                      value={this.contract.client_id}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.clients}
                      disabled={true}
                    />
                    <InputForm
                      name="phone"
                      label="Teléfono"
                      value={this.contract.client_phone}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                      disabled={true}
                    />
                    <InputForm
                      name="other_phones"
                      label="Otros Telefonos"
                      value={this.contract.other_phones}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="package_id"
                      label="Paquete"
                      value={this.contract.package_id}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.packages}
                      disabled={false}
                    />
                    <InputForm
                      name="balance"
                      label="Saldo a favor"
                      value={this.contract.balance}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="number"
                      decimal={2}
                      thousandSeparator={true}
                      disabled={false}
                    />
                    <InputForm
                      name="due_balance"
                      label="Saldo deudor"
                      value={this.contract.due_balance}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="number"
                      decimal={2}
                      thousandSeparator={true}
                      disabled={false}
                    />
                    <InputForm
                      name="sectorial_id"
                      label="Sectorial"
                      value={this.contract.sectorial_id}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      options={this.sectorials}
                      type="select"
                    />
                    <InputForm
                      name="ip"
                      label="Elegir otra IP"
                      value={this.contract.ip}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      options={this.availableIps}
                      type="select"
                    />
                    { this.hasPorts && 
                    <InputForm
                      name="port"
                      label="Elegir otro Puerto"
                      value={this.contract.port}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      options={this.availablePorts}
                      type="select"
                    />
                    }
                    <InputForm
                      name="mac"
                      label="Mac Adress"
                      value={this.contract.mac}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="reference"
                      label="Referencia"
                      value={this.contract.reference}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="reference_phone"
                      label="Teléfono de Referencia"
                      value={this.contract.reference_phone}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="number"
                      format={"###-###-####"}
                    />
                    <InputForm
                      name="reference_relationship"
                      label="Relación de Referencia"
                      value={this.contract.reference_relationship}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_street"
                      label="Dirección del Contrato"
                      value={this.contract.address_street}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_colonia"
                      label="Colonia"
                      value={this.contract.address_colonia}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_interior"
                      label="Número Interior"
                      value={this.contract.address_interior}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_exterior"
                      label="Número Exterior"
                      value={this.contract.address_exterior}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_zipcode"
                      label="Codigo Postal"
                      value={this.contract.address_zipcode}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="number"
                      format={"#####"}
                    />
                    <InputForm
                      name="address_reference"
                      label="Referencias del lugar"
                      value={this.contract.address_reference}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="payment_type"
                      label="Forma de Pago"
                      value={this.contract.payment_type}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.payment_types}
                    />
                    <InputForm
                      name="house_type"
                      label="Tipo de Casa"
                      value={this.contract.house_type}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.house_types}
                    />
                    <InputForm
                      name="collection_time"
                      label="Horario de cobro preferido"
                      value={this.contract.collection_time}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="cutoff_date_id"
                      label="Fecha de Corte"
                      value={this.contract.cutoff_date_id}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.cutoffs.map((value: any) => {
                        return {
                          id: value.id,
                          name:
                            "Dia " +
                            value.date +
                            " - (" +
                            value.contracts +
                            " contratos)",
                        };
                      })}
                    />
                    <InputForm
                      name="notes_creation"
                      label="Notas (Max: 255 caracteres)"
                      value={this.contract.notes_creation}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="textarea"
                      maxLength={255}
                    />
                    <div className="row" id="datos-fiscales-section">
                      <div className="col-sm-12 text-center">
                        <h4 className="card-title">Datos fiscales</h4>
                        <h6 className="card-subtitle">
                          Si no tiene RFC, dejar en blanco
                        </h6>
                      </div>
                    </div>
                    <InputForm
                      name="rfc"
                      label="RFC"
                      value={this.contract.rfc}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="razon_social"
                      label="Razón Social"
                      value={this.contract.razon_social}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="regimen_fiscal"
                      label="Régimen Fiscal"
                      value={this.contract.regimen_fiscal}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="select"
                      options={this.regimen_fiscal}
                    />
                    <InputForm
                      name="uso_cfdi"
                      label="Uso De CFDI"
                      value={this.contract.uso_cfdi}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="select"
                      options={this.usos_cfdi}
                    />
                    <InputForm
                      name="factura_calle"
                      label="Calle"
                      value={this.contract.factura_calle}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_colonia"
                      label="Colonia"
                      value={this.contract.factura_colonia}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_interior"
                      label="Número Interior (Dejar en blanco si no aplica)"
                      value={this.contract.factura_interior}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_exterior"
                      label="Número Exterior"
                      value={this.contract.factura_exterior}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_ciudad"
                      label="Ciudad"
                      value={this.contract.factura_ciudad}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_estado"
                      label="Estado"
                      value={this.contract.factura_estado}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_cp"
                      label="Código Postal"
                      value={this.contract.factura_cp}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="status"
                      label="Estado del contrato"
                      value={this.contract.status}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      options={this.statuses}
                      type="select"
                    />
                    <button
                      onClick={this.addNotes}
                      type="submit"
                      className="btn btn-primary pull-right"
                    >
                      Guardar cambios
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        );
    }
}